import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useApi } from '../../services/ApiServices'; // Servicio para hacer las solicitudes a la API
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Loader from '../../components/Loader.jsx';
import Grid2 from '@mui/material/Grid2/Grid2';
import './Activation.css';
import { Typography, Box, Button } from '@mui/material';
import { UserDTO } from '../../interfaces/Login.interface';
import { useAuth } from '../../components/Auth/AuthContext';

function Activation() {
  const { ApiRequestActivation, ApiRequest } = useApi();
  const { login } = useAuth();
  const [searchParams] = useSearchParams();
  const mail = searchParams.get("correo");
  const token = searchParams.get("token");

  const [isLoading, setIsLoading] = useState(false);
  const [activationSuccess, setActivationSuccess] = useState(false);
  const [activationAttempted, setActivationAttempted] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await handleActivateAccount();
    };

    fetchData();
  }, []);

  // Función que se llama al hacer clic para activar la cuenta
  const handleActivateAccount = async () => {
    if (!mail || !token) return; // Verifica que los parámetros estén disponibles

    setIsLoading(true); // Inicia el estado de carga

    try {
      const activation = await ApiRequest(`api/Auth/ValidarCorreo?correo=${mail}&token=${token}`, 'GET', null, true);
      console.log('activation response:', activation);
      const user = await ApiRequestActivation(`api/Auth/BuscarUsuarioPorMail?email=${mail}`, 'GET', token);
      console.log('data response:', user);
      const data: UserDTO = user;

      if (data && user !== null) {
        login(user, token);
      } else {
        alert('Error al iniciar sesión');
      }
      setActivationSuccess(true); // Marca que la activación fue exitosa
    } catch (error) {
      console.error('Error activating account:', error);
      setActivationSuccess(false); // Marca que la activación falló
    } finally {
      setIsLoading(false); // Finaliza el estado de carga
      setActivationAttempted(true); // Marca que se intentó la activación
    }
  };

  return (
    <Grid2 container direction="column" justifyContent="space-between" className="activation-container">
      <Header />
      {isLoading ? (
        <Loader />
      ) : (
        <Box className="activation-message-box" display="flex" justifyContent="center" alignItems="center">
          {activationSuccess ? (
            <Typography variant="h4" className="activation-message">
              ¡Felicidades! Tu cuenta ha sido activada correctamente. 🎉
            </Typography>
          ) : activationAttempted ? (
            <Typography variant="h5" color="error" className="activation-message">
              Lo sentimos, no pudimos activar tu cuenta. Por favor, intenta de nuevo.
            </Typography>
          ) : (
            <Typography variant="h5" className="activation-message">
              Reintentar
            </Typography>
          )}
        </Box>
      )}
      
      {/* Solo muestra el botón si no se ha intentado la activación aún */}
      {!activationAttempted && (
        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleActivateAccount}
            disabled={isLoading}
          >
            Activar Cuenta
          </Button>
        </Box>
      )}

      <Footer />
    </Grid2>
  );
}

export default Activation;
